
export enum ErrorType {
    MainAsset,
    SimFatal,
    SimWarning,
    FileSetup
}
